import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

export default function NeurocognitiveIcon({ size = 40, withCircle = true, color }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 40 40";
  const iconTransform = withCircle ? "" : "translate(-20 -20)";

  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <path
          d="M25.2796 46L26.2796 46.3234V51.5718C26.2859 53.7984 28.0937 55.5998 30.3204 55.5998H34.364L34.9921 57.5998C35.2406 58.4498 36.1312 58.9358 36.9797 58.6874C37.8297 58.4389 38.3172 57.5498 38.0687 56.6998L37.1125 53.5436C36.9094 52.8624 36.2828 52.3967 35.5719 52.3998H30.3203C29.8562 52.3998 29.4796 52.0233 29.4796 51.5592V45.1592C29.4796 44.467 29.0343 43.8545 28.3765 43.6404L26.7203 43.1154L29.3484 37.2202C29.4437 37.0015 29.4921 36.764 29.4874 36.5234C29.4421 32.367 31.5499 28.4826 35.0594 26.2562C36.9704 25.0374 39.1938 24.3999 41.4594 24.4202H41.4954C44.5376 24.4343 47.4594 25.6015 49.6718 27.6874C51.8842 29.7734 53.2218 32.6218 53.4155 35.6562C53.6187 38.7719 52.5859 41.8406 50.5405 44.1998C50.239 44.553 50.0249 44.9717 49.9155 45.4233C49.7859 45.9514 49.7984 46.503 49.9515 47.0233L52.503 55.5281H52.5046C52.7484 56.3828 53.6405 56.8765 54.4952 56.6312C55.3515 56.3874 55.8452 55.4953 55.5999 54.6406L53.1999 46.7998C53.0952 46.4388 53.1734 46.0498 53.4077 45.756C55.7062 42.8451 56.8468 39.1856 56.6077 35.484C56.3702 31.6324 54.6765 28.0152 51.8717 25.3668C49.0655 22.7184 45.3577 21.2356 41.4997 21.22H41.4591C38.4482 21.1981 35.4999 22.0903 33.0043 23.7762C28.8511 26.5669 26.3371 31.223 26.2839 36.2278L23.6308 42.187C23.4745 42.5277 23.3839 42.8933 23.3683 43.2683C23.3339 44.4995 24.1105 45.6089 25.2792 45.9995L25.2796 46Z"
          fill={color}
        />
        <path
          d="M50.2361 36.4C50.2329 33.6594 48.9517 31.0752 46.7704 29.414C44.5907 27.7515 41.7612 27.2015 39.1156 27.9234C36.3891 28.6453 34.1892 30.6593 33.228 33.3126C32.9686 34.0173 33.0702 34.8032 33.4999 35.4188C33.9296 36.0344 34.6327 36.4001 35.3843 36.4001H40.4795C43.0873 36.4047 45.1999 38.5204 45.1999 41.1281C45.203 41.8031 45.6233 42.4062 46.2577 42.6421C46.8905 42.8781 47.603 42.6968 48.0483 42.1875C49.4577 40.589 50.2361 38.5314 50.2361 36.4Z"
          fill={color}
        />
      </g>
    </Svg>
  );
}
